/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type RegisterUserInput = {
  firstName: string,
  lastName: string,
  dateOfBirth: string,
  nationOfBirth: string,
  provinceOfBirth: string,
  birthPlace: string,
  nationality: string,
  gender: string,
  fiscalCode: string,
  fiscalCodeConfirm: boolean,
  country: string,
  province: string,
  city: string,
  address: string,
  houseNumber: string,
  zipCode: string,
  mobileNumberPrefix: string,
  mobileNumber: string,
  phoneNumberPrefix?: string | null,
  phoneNumber?: string | null,
  documentType: DocumentType,
  number: string,
  releaseDate: string,
  expirationDate: string,
  releasedBy: string,
  nickname: string,
  email: string,
  securityQuestion: string,
  secretAnswer: string,
  presenterCode?: string | null,
  promoCode?: string | null,
  period: Period,
  depositLimit?: number | null,
  confirmDepositLimit?: boolean | null,
  adultYes?: boolean | null,
  termsAndConditionYes?: boolean | null,
  privacyTerms?: boolean | null,
  newsletterYes?: boolean | null,
  currency?: string | null,
};

export enum DocumentType {
  NONE = "NONE",
  IDENTITY_CARD = "IDENTITY_CARD",
  PASSPORT = "PASSPORT",
  DRIVING_LICENSE = "DRIVING_LICENSE",
  FIREARMS_LICENSE = "FIREARMS_LICENSE",
  BOAT_LICENSE = "BOAT_LICENSE",
  PENSION_BOOK = "PENSION_BOOK",
  OTHER = "OTHER",
}


export enum Period {
  NONE = "NONE",
  WEEK = "WEEK",
  MONTH = "MONTH",
}


export type User = {
  __typename: "User",
  PK: string,
  SK: string,
  firstName: string,
  lastName: string,
  dateOfBirth: string,
  nationOfBirth: string,
  provinceOfBirth: string,
  birthPlace: string,
  nationality: string,
  gender: string,
  fiscalCode: string,
  fiscalCodeConfirm: boolean,
  country: string,
  province: string,
  city: string,
  address: string,
  houseNumber: string,
  zipCode: string,
  mobileNumberPrefix: string,
  mobileNumber: string,
  phoneNumberPrefix?: string | null,
  phoneNumber?: string | null,
  documentType: DocumentType,
  number: string,
  releaseDate: string,
  expirationDate: string,
  releasedBy: string,
  nickname: string,
  email: string,
  securityQuestion: string,
  secretAnswer: string,
  presenterCode?: string | null,
  promoCode?: string | null,
  period: Period,
  depositLimit?: number | null,
  confirmDepositLimit?: boolean | null,
  adultYes?: boolean | null,
  termsAndConditionYes?: boolean | null,
  privacyTerms?: boolean | null,
  newsletterYes?: boolean | null,
  createdAt: string,
  userStatus: UserStatus,
};

export enum UserStatus {
  NONE = "NONE",
  New = "New",
  Active = "Active",
  Disabled = "Disabled",
}


export type UserAddressDataInput = {
  country: string,
  province: string,
  city: string,
  address: string,
  houseNumber: string,
  zipCode: string,
  mobileNumberPrefix: string,
  mobileNumber: string,
  phoneNumberPrefix?: string | null,
  phoneNumber?: string | null,
};

export type DepositOrderInput = {
  orderId: string,
  amount: number,
  valute: string,
  description: string,
  provider?: PaymentProvider | null,
  id: string,
};

export enum PaymentProvider {
  PAYPAL = "PAYPAL",
}


export type DepositOrder = {
  __typename: "DepositOrder",
  orderId: string,
  amount: number,
  valute: string,
  description: string,
};

export type AtlasSessionToken = {
  __typename: "AtlasSessionToken",
  clientInternalId?: string | null,
  sessionToken?: string | null,
};

export type SessionManagementResult = {
  __typename: "SessionManagementResult",
  success?: boolean | null,
  ext?: string | null,
};

export type MessageInput = {
  messageText: string,
  messageCategory: MessageCategory,
  messageSubject: string,
};

export enum MessageCategory {
  BONUS = "BONUS",
  COMMUNICATION = "COMMUNICATION",
  INFO = "INFO",
}


export type Message = {
  __typename: "Message",
  PK: string,
  SK: string,
  messageText?: string | null,
  messageCategory?: MessageCategory | null,
  createdAt?: string | null,
  author?: string | null,
  messageSubject?: string | null,
};

export type Account = {
  __typename: "Account",
  PK: string,
  SK: string,
  accountState?: string | null,
  deposit?: number | null,
  bonus?: number | null,
  withdrawable?: number | null,
  valute?: string | null,
  createdAt?: string | null,
  lastDepositDate?: string | null,
  weekTotal?: number | null,
  monthTotal?: number | null,
  depositLimit?: number | null,
  depositLimitPeriod?: Period | null,
  pickedUp?: number | null,
  expenses?: number | null,
  updatedAt?: string | null,
  winnings?: number | null,
};

export type WinningsUsers = {
  __typename: "WinningsUsers",
  username?: string | null,
  amount?: number | null,
  amountWinning?: number | null,
  valute?: string | null,
};

export type PlayerBookmark = {
  __typename: "PlayerBookmark",
  PK?: string | null,
  SK?: string | null,
  gameIds?: string | null,
};

export type MessageFilterInput = {
  text?: string | null,
  dateStart?: string | null,
  dateEnd?: string | null,
  category?: string | null,
};

export type MessageConnection = {
  __typename: "MessageConnection",
  items?:  Array<MessageListItem | null > | null,
  nextToken?: string | null,
};

export type MessageListItem = {
  __typename: "MessageListItem",
  PK: string,
  SK: string,
  messageCategory?: MessageCategory | null,
  createdAt?: string | null,
  author?: string | null,
  messageSubject?: string | null,
  readed?: boolean | null,
};

export type MessagesStat = {
  __typename: "MessagesStat",
  newMessages?: number | null,
  readedMessages?: number | null,
};

export type AccountMovementConnection = {
  __typename: "AccountMovementConnection",
  items?:  Array<AccountMovement | null > | null,
  nextToken?: string | null,
};

export type AccountMovement = {
  __typename: "AccountMovement",
  PK: string,
  SK: string,
  orderId: string,
  createdAt: string,
  valute?: string | null,
  gameSession?: string | null,
  provider_hook?: string | null,
  updatedAt?: string | null,
  amount?: number | null,
  provider?: string | null,
  username?: string | null,
  description?: string | null,
  provider_hook_event?: string | null,
  id?: string | null,
  status?: string | null,
  amountWinning?: number | null,
  sign?: string | null,
};

export type Kiosk = {
  __typename: "Kiosk",
  PK?: string | null,
  SK?: string | null,
  name?: string | null,
  id?: string | null,
  cash?: Cash | null,
  station?: string | null,
  backgroundImg?: string | null,
};

export type Cash = {
  __typename: "Cash",
  PK: string,
  SK: string,
  address?: string | null,
  city?: string | null,
  confirmDepositLimit?: boolean | null,
  country?: string | null,
  createdAt?: string | null,
  depositLimit?: number | null,
  firstName?: string | null,
  houseNumber?: string | null,
  lastName?: string | null,
  nickname?: string | null,
  period?: string | null,
  province?: string | null,
  updatedAt?: string | null,
  userStatus?: string | null,
  zipCode?: string | null,
  account?: Account | null,
};

export type GameCompany = {
  __typename: "GameCompany",
  PK?: string | null,
  SK?: string | null,
  id?: string | null,
  name?: string | null,
  games?:  Array<Game | null > | null,
  sections?: string | null,
  apiOperator?: string | null,
  urlEndPoint?: string | null,
};

export type Game = {
  __typename: "Game",
  PK?: string | null,
  SK?: string | null,
  id?: string | null,
  name?: string | null,
  category?: string | null,
  subcategory?: string | null,
  gamedata?: string | null,
  showLabel?: string | null,
  apiOperator?: string | null,
  urlEndPoint?: string | null,
  vendor?: string | null,
  updatedAt?: string | null,
  gameLaunchUrl?: string | null,
};

export type GameListConnection = {
  __typename: "GameListConnection",
  items?:  Array<Game | null > | null,
  nextToken?: string | null,
};

export type GameCategoryStat = {
  __typename: "GameCategoryStat",
  PK?: string | null,
  SK?: string | null,
  number?: number | null,
  subs?: string | null,
  vendors?: string | null,
  updatedAt?: string | null,
};

export type GameSession = {
  __typename: "GameSession",
  PK?: string | null,
  SK?: string | null,
  lang?: string | null,
  currency?: string | null,
  username?: string | null,
  live?: string | null,
  gameId?: string | null,
  demo?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  liveUpdatedAt?: string | null,
  level?: string | null,
  buyIn?: number | null,
  expenses?: number | null,
  winnings?: number | null,
  balance?: number | null,
  game?: Game | null,
};

export type AccountMovementCashDeskConnection = {
  __typename: "AccountMovementCashDeskConnection",
  items?:  Array<AccountMovementCashDesk | null > | null,
  nextToken?: string | null,
};

export type AccountMovementCashDesk = {
  __typename: "AccountMovementCashDesk",
  PK: string,
  SK: string,
  orderId: string,
  createdAt: string,
  valute?: string | null,
  gameSession?: string | null,
  provider_hook?: string | null,
  updatedAt?: string | null,
  amount?: number | null,
  provider?: string | null,
  username?: string | null,
  description?: string | null,
  provider_hook_event?: string | null,
  id?: string | null,
  paymentStatus?: string | null,
  status?: string | null,
  amountWinning?: number | null,
  contract?: string | null,
  note?: string | null,
  desk?: CashDesk | null,
  sign?: string | null,
};

export type CashDesk = {
  __typename: "CashDesk",
  PK?: string | null,
  SK?: string | null,
  name?: string | null,
  id?: string | null,
  cash?: Cash | null,
  station?: string | null,
  backgroundImg?: string | null,
  screenLocked?: boolean | null,
};

export type Contract = {
  __typename: "Contract",
  PK?: string | null,
  SK?: string | null,
  createdAt?: string | null,
};

export type RegisterUserMutationVariables = {
  user: RegisterUserInput,
  password: string,
};

export type RegisterUserMutation = {
  registerUser?:  {
    __typename: "User",
    PK: string,
    SK: string,
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    nationOfBirth: string,
    provinceOfBirth: string,
    birthPlace: string,
    nationality: string,
    gender: string,
    fiscalCode: string,
    fiscalCodeConfirm: boolean,
    country: string,
    province: string,
    city: string,
    address: string,
    houseNumber: string,
    zipCode: string,
    mobileNumberPrefix: string,
    mobileNumber: string,
    phoneNumberPrefix?: string | null,
    phoneNumber?: string | null,
    documentType: DocumentType,
    number: string,
    releaseDate: string,
    expirationDate: string,
    releasedBy: string,
    nickname: string,
    email: string,
    securityQuestion: string,
    secretAnswer: string,
    presenterCode?: string | null,
    promoCode?: string | null,
    period: Period,
    depositLimit?: number | null,
    confirmDepositLimit?: boolean | null,
    adultYes?: boolean | null,
    termsAndConditionYes?: boolean | null,
    privacyTerms?: boolean | null,
    newsletterYes?: boolean | null,
    createdAt: string,
    userStatus: UserStatus,
  } | null,
};

export type ChangeAddressDataMutationVariables = {
  addressData: UserAddressDataInput,
  password: string,
};

export type ChangeAddressDataMutation = {
  changeAddressData?: boolean | null,
};

export type MakeDepositOrderMutationVariables = {
  input?: DepositOrderInput | null,
};

export type MakeDepositOrderMutation = {
  makeDepositOrder?:  {
    __typename: "DepositOrder",
    orderId: string,
    amount: number,
    valute: string,
    description: string,
  } | null,
};

export type GenerateGameSessionTokenMutationVariables = {
  currency: string,
  lang: string,
};

export type GenerateGameSessionTokenMutation = {
  generateGameSessionToken?: string | null,
};

export type GenerateGameSessionTokenTimelessTechMutationVariables = {
  currency: string,
  lang: string,
  gameId?: string | null,
  buyIn?: number | null,
  category: string,
};

export type GenerateGameSessionTokenTimelessTechMutation = {
  generateGameSessionTokenTimelessTech?: string | null,
};

export type GenerateGameSessionTokenBetradarMutationVariables = {
  currency: string,
  lang: string,
  gameId?: string | null,
  buyIn?: number | null,
  category: string,
};

export type GenerateGameSessionTokenBetradarMutation = {
  generateGameSessionTokenBetradar?: string | null,
};

export type GenerateGameSessionTokenAtlasMutationVariables = {
  staging: boolean,
  lang: string,
  category: string,
  currency: string,
  ip?: string | null,
};

export type GenerateGameSessionTokenAtlasMutation = {
  generateGameSessionTokenAtlas?:  {
    __typename: "AtlasSessionToken",
    clientInternalId?: string | null,
    sessionToken?: string | null,
  } | null,
};

export type SessionManagementMutationVariables = {
  session: string,
  oper: string,
};

export type SessionManagementMutation = {
  sessionManagement?:  {
    __typename: "SessionManagementResult",
    success?: boolean | null,
    ext?: string | null,
  } | null,
};

export type CreateMessageMutationVariables = {
  input: MessageInput,
  to: string,
};

export type CreateMessageMutation = {
  createMessage?:  {
    __typename: "Message",
    PK: string,
    SK: string,
    messageText?: string | null,
    messageCategory?: MessageCategory | null,
    createdAt?: string | null,
    author?: string | null,
    messageSubject?: string | null,
  } | null,
};

export type NotifyPlaceBetMutationVariables = {
  username: string,
};

export type NotifyPlaceBetMutation = {
  notifyPlaceBet?:  {
    __typename: "Account",
    PK: string,
    SK: string,
    accountState?: string | null,
    deposit?: number | null,
    bonus?: number | null,
    withdrawable?: number | null,
    valute?: string | null,
    createdAt?: string | null,
    lastDepositDate?: string | null,
    weekTotal?: number | null,
    monthTotal?: number | null,
    depositLimit?: number | null,
    depositLimitPeriod?: Period | null,
    pickedUp?: number | null,
    expenses?: number | null,
    updatedAt?: string | null,
    winnings?: number | null,
  } | null,
};

export type NotifyWinningMutationVariables = {
  limit?: number | null,
  dal: number,
  al: number,
};

export type NotifyWinningMutation = {
  notifyWinning?:  Array< {
    __typename: "WinningsUsers",
    username?: string | null,
    amount?: number | null,
    amountWinning?: number | null,
    valute?: string | null,
  } | null > | null,
};

export type MakeWithdrawalMutationVariables = {
  amount?: number | null,
  method: string,
};

export type MakeWithdrawalMutation = {
  makeWithdrawal?:  {
    __typename: "Account",
    PK: string,
    SK: string,
    accountState?: string | null,
    deposit?: number | null,
    bonus?: number | null,
    withdrawable?: number | null,
    valute?: string | null,
    createdAt?: string | null,
    lastDepositDate?: string | null,
    weekTotal?: number | null,
    monthTotal?: number | null,
    depositLimit?: number | null,
    depositLimitPeriod?: Period | null,
    pickedUp?: number | null,
    expenses?: number | null,
    updatedAt?: string | null,
    winnings?: number | null,
  } | null,
};

export type UpdateGameBookmarkMutationVariables = {
  section?: string | null,
  gameIds?: string | null,
};

export type UpdateGameBookmarkMutation = {
  updateGameBookmark?:  {
    __typename: "PlayerBookmark",
    PK?: string | null,
    SK?: string | null,
    gameIds?: string | null,
  } | null,
};

export type CheckUsernameExistsQueryVariables = {
  username: string,
};

export type CheckUsernameExistsQuery = {
  checkUsernameExists?: boolean | null,
};

export type GetPersonalDataQuery = {
  getPersonalData?:  {
    __typename: "User",
    PK: string,
    SK: string,
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    nationOfBirth: string,
    provinceOfBirth: string,
    birthPlace: string,
    nationality: string,
    gender: string,
    fiscalCode: string,
    fiscalCodeConfirm: boolean,
    country: string,
    province: string,
    city: string,
    address: string,
    houseNumber: string,
    zipCode: string,
    mobileNumberPrefix: string,
    mobileNumber: string,
    phoneNumberPrefix?: string | null,
    phoneNumber?: string | null,
    documentType: DocumentType,
    number: string,
    releaseDate: string,
    expirationDate: string,
    releasedBy: string,
    nickname: string,
    email: string,
    securityQuestion: string,
    secretAnswer: string,
    presenterCode?: string | null,
    promoCode?: string | null,
    period: Period,
    depositLimit?: number | null,
    confirmDepositLimit?: boolean | null,
    adultYes?: boolean | null,
    termsAndConditionYes?: boolean | null,
    privacyTerms?: boolean | null,
    newsletterYes?: boolean | null,
    createdAt: string,
    userStatus: UserStatus,
  } | null,
};

export type CheckAccountStateQuery = {
  checkAccountState?:  {
    __typename: "Account",
    PK: string,
    SK: string,
    accountState?: string | null,
    deposit?: number | null,
    bonus?: number | null,
    withdrawable?: number | null,
    valute?: string | null,
    createdAt?: string | null,
    lastDepositDate?: string | null,
    weekTotal?: number | null,
    monthTotal?: number | null,
    depositLimit?: number | null,
    depositLimitPeriod?: Period | null,
    pickedUp?: number | null,
    expenses?: number | null,
    updatedAt?: string | null,
    winnings?: number | null,
  } | null,
};

export type GetMessagesQueryVariables = {
  limit?: number | null,
  filter?: MessageFilterInput | null,
  nextToken?: string | null,
};

export type GetMessagesQuery = {
  getMessages?:  {
    __typename: "MessageConnection",
    items?:  Array< {
      __typename: "MessageListItem",
      PK: string,
      SK: string,
      messageCategory?: MessageCategory | null,
      createdAt?: string | null,
      author?: string | null,
      messageSubject?: string | null,
      readed?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMessageQueryVariables = {
  PK: string,
  SK: string,
  readed: string,
};

export type GetMessageQuery = {
  getMessage?:  {
    __typename: "Message",
    PK: string,
    SK: string,
    messageText?: string | null,
    messageCategory?: MessageCategory | null,
    createdAt?: string | null,
    author?: string | null,
    messageSubject?: string | null,
  } | null,
};

export type GetMessagesStatQuery = {
  getMessagesStat?:  {
    __typename: "MessagesStat",
    newMessages?: number | null,
    readedMessages?: number | null,
  } | null,
};

export type GetMovementsListQuery = {
  getMovementsList?:  {
    __typename: "AccountMovementConnection",
    items?:  Array< {
      __typename: "AccountMovement",
      PK: string,
      SK: string,
      orderId: string,
      createdAt: string,
      valute?: string | null,
      gameSession?: string | null,
      provider_hook?: string | null,
      updatedAt?: string | null,
      amount?: number | null,
      provider?: string | null,
      username?: string | null,
      description?: string | null,
      provider_hook_event?: string | null,
      id?: string | null,
      status?: string | null,
      amountWinning?: number | null,
      sign?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPendingWithdrawalQuery = {
  getPendingWithdrawal?:  {
    __typename: "AccountMovementConnection",
    items?:  Array< {
      __typename: "AccountMovement",
      PK: string,
      SK: string,
      orderId: string,
      createdAt: string,
      valute?: string | null,
      gameSession?: string | null,
      provider_hook?: string | null,
      updatedAt?: string | null,
      amount?: number | null,
      provider?: string | null,
      username?: string | null,
      description?: string | null,
      provider_hook_event?: string | null,
      id?: string | null,
      status?: string | null,
      amountWinning?: number | null,
      sign?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMovementQueryVariables = {
  PK: string,
};

export type GetMovementQuery = {
  getMovement?:  {
    __typename: "AccountMovement",
    PK: string,
    SK: string,
    orderId: string,
    createdAt: string,
    valute?: string | null,
    gameSession?: string | null,
    provider_hook?: string | null,
    updatedAt?: string | null,
    amount?: number | null,
    provider?: string | null,
    username?: string | null,
    description?: string | null,
    provider_hook_event?: string | null,
    id?: string | null,
    status?: string | null,
    amountWinning?: number | null,
    sign?: string | null,
  } | null,
};

export type GetLatestWinnersQueryVariables = {
  limit?: number | null,
  dal: number,
  al: number,
};

export type GetLatestWinnersQuery = {
  getLatestWinners?:  Array< {
    __typename: "WinningsUsers",
    username?: string | null,
    amount?: number | null,
    amountWinning?: number | null,
    valute?: string | null,
  } | null > | null,
};

export type GetKioskDataQuery = {
  getKioskData?:  {
    __typename: "Kiosk",
    PK?: string | null,
    SK?: string | null,
    name?: string | null,
    id?: string | null,
    cash?:  {
      __typename: "Cash",
      PK: string,
      SK: string,
      address?: string | null,
      city?: string | null,
      confirmDepositLimit?: boolean | null,
      country?: string | null,
      createdAt?: string | null,
      depositLimit?: number | null,
      firstName?: string | null,
      houseNumber?: string | null,
      lastName?: string | null,
      nickname?: string | null,
      period?: string | null,
      province?: string | null,
      updatedAt?: string | null,
      userStatus?: string | null,
      zipCode?: string | null,
      account?:  {
        __typename: "Account",
        PK: string,
        SK: string,
        accountState?: string | null,
        deposit?: number | null,
        bonus?: number | null,
        withdrawable?: number | null,
        valute?: string | null,
        createdAt?: string | null,
        lastDepositDate?: string | null,
        weekTotal?: number | null,
        monthTotal?: number | null,
        depositLimit?: number | null,
        depositLimitPeriod?: Period | null,
        pickedUp?: number | null,
        expenses?: number | null,
        updatedAt?: string | null,
        winnings?: number | null,
      } | null,
    } | null,
    station?: string | null,
    backgroundImg?: string | null,
  } | null,
};

export type GetGameCompanyListQuery = {
  getGameCompanyList?:  Array< {
    __typename: "GameCompany",
    PK?: string | null,
    SK?: string | null,
    id?: string | null,
    name?: string | null,
    games?:  Array< {
      __typename: "Game",
      PK?: string | null,
      SK?: string | null,
      id?: string | null,
      name?: string | null,
      category?: string | null,
      subcategory?: string | null,
      gamedata?: string | null,
      showLabel?: string | null,
      apiOperator?: string | null,
      urlEndPoint?: string | null,
      vendor?: string | null,
      updatedAt?: string | null,
      gameLaunchUrl?: string | null,
    } | null > | null,
    sections?: string | null,
    apiOperator?: string | null,
    urlEndPoint?: string | null,
  } | null > | null,
};

export type GetGameCompanyQueryVariables = {
  name: string,
};

export type GetGameCompanyQuery = {
  getGameCompany?:  {
    __typename: "GameCompany",
    PK?: string | null,
    SK?: string | null,
    id?: string | null,
    name?: string | null,
    games?:  Array< {
      __typename: "Game",
      PK?: string | null,
      SK?: string | null,
      id?: string | null,
      name?: string | null,
      category?: string | null,
      subcategory?: string | null,
      gamedata?: string | null,
      showLabel?: string | null,
      apiOperator?: string | null,
      urlEndPoint?: string | null,
      vendor?: string | null,
      updatedAt?: string | null,
      gameLaunchUrl?: string | null,
    } | null > | null,
    sections?: string | null,
    apiOperator?: string | null,
    urlEndPoint?: string | null,
  } | null,
};

export type GetGamesListByCompanyQueryVariables = {
  gameCompany: string,
  category?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetGamesListByCompanyQuery = {
  getGamesListByCompany?:  {
    __typename: "GameListConnection",
    items?:  Array< {
      __typename: "Game",
      PK?: string | null,
      SK?: string | null,
      id?: string | null,
      name?: string | null,
      category?: string | null,
      subcategory?: string | null,
      gamedata?: string | null,
      showLabel?: string | null,
      apiOperator?: string | null,
      urlEndPoint?: string | null,
      vendor?: string | null,
      updatedAt?: string | null,
      gameLaunchUrl?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetGamesListQueryVariables = {
  category: string,
  subcategory?: string | null,
  vendor?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetGamesListQuery = {
  getGamesList?:  {
    __typename: "GameListConnection",
    items?:  Array< {
      __typename: "Game",
      PK?: string | null,
      SK?: string | null,
      id?: string | null,
      name?: string | null,
      category?: string | null,
      subcategory?: string | null,
      gamedata?: string | null,
      showLabel?: string | null,
      apiOperator?: string | null,
      urlEndPoint?: string | null,
      vendor?: string | null,
      updatedAt?: string | null,
      gameLaunchUrl?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetGameCategoryStatQueryVariables = {
  category: string,
};

export type GetGameCategoryStatQuery = {
  getGameCategoryStat?:  {
    __typename: "GameCategoryStat",
    PK?: string | null,
    SK?: string | null,
    number?: number | null,
    subs?: string | null,
    vendors?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type GetGameByIdQueryVariables = {
  gameId?: string | null,
};

export type GetGameByIdQuery = {
  getGameById?:  {
    __typename: "Game",
    PK?: string | null,
    SK?: string | null,
    id?: string | null,
    name?: string | null,
    category?: string | null,
    subcategory?: string | null,
    gamedata?: string | null,
    showLabel?: string | null,
    apiOperator?: string | null,
    urlEndPoint?: string | null,
    vendor?: string | null,
    updatedAt?: string | null,
    gameLaunchUrl?: string | null,
  } | null,
};

export type GetGameQueryVariables = {
  PK: string,
  SK: string,
};

export type GetGameQuery = {
  getGame?:  {
    __typename: "Game",
    PK?: string | null,
    SK?: string | null,
    id?: string | null,
    name?: string | null,
    category?: string | null,
    subcategory?: string | null,
    gamedata?: string | null,
    showLabel?: string | null,
    apiOperator?: string | null,
    urlEndPoint?: string | null,
    vendor?: string | null,
    updatedAt?: string | null,
    gameLaunchUrl?: string | null,
  } | null,
};

export type GetSessionDataQueryVariables = {
  sessionId?: string | null,
};

export type GetSessionDataQuery = {
  getSessionData?:  {
    __typename: "GameSession",
    PK?: string | null,
    SK?: string | null,
    lang?: string | null,
    currency?: string | null,
    username?: string | null,
    live?: string | null,
    gameId?: string | null,
    demo?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    liveUpdatedAt?: string | null,
    level?: string | null,
    buyIn?: number | null,
    expenses?: number | null,
    winnings?: number | null,
    balance?: number | null,
    game?:  {
      __typename: "Game",
      PK?: string | null,
      SK?: string | null,
      id?: string | null,
      name?: string | null,
      category?: string | null,
      subcategory?: string | null,
      gamedata?: string | null,
      showLabel?: string | null,
      apiOperator?: string | null,
      urlEndPoint?: string | null,
      vendor?: string | null,
      updatedAt?: string | null,
      gameLaunchUrl?: string | null,
    } | null,
  } | null,
};

export type CheckLiveSessionQueryVariables = {
  provider?: string | null,
};

export type CheckLiveSessionQuery = {
  checkLiveSession?:  Array< {
    __typename: "GameSession",
    PK?: string | null,
    SK?: string | null,
    lang?: string | null,
    currency?: string | null,
    username?: string | null,
    live?: string | null,
    gameId?: string | null,
    demo?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    liveUpdatedAt?: string | null,
    level?: string | null,
    buyIn?: number | null,
    expenses?: number | null,
    winnings?: number | null,
    balance?: number | null,
    game?:  {
      __typename: "Game",
      PK?: string | null,
      SK?: string | null,
      id?: string | null,
      name?: string | null,
      category?: string | null,
      subcategory?: string | null,
      gamedata?: string | null,
      showLabel?: string | null,
      apiOperator?: string | null,
      urlEndPoint?: string | null,
      vendor?: string | null,
      updatedAt?: string | null,
      gameLaunchUrl?: string | null,
    } | null,
  } | null > | null,
};

export type GetPlayerBookmarkQueryVariables = {
  section: string,
};

export type GetPlayerBookmarkQuery = {
  getPlayerBookmark?:  {
    __typename: "PlayerBookmark",
    PK?: string | null,
    SK?: string | null,
    gameIds?: string | null,
  } | null,
};

export type GetConfigQuery = {
  getConfig?: string | null,
};

export type GetCashMovementsListQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetCashMovementsListQuery = {
  getCashMovementsList?:  {
    __typename: "AccountMovementCashDeskConnection",
    items?:  Array< {
      __typename: "AccountMovementCashDesk",
      PK: string,
      SK: string,
      orderId: string,
      createdAt: string,
      valute?: string | null,
      gameSession?: string | null,
      provider_hook?: string | null,
      updatedAt?: string | null,
      amount?: number | null,
      provider?: string | null,
      username?: string | null,
      description?: string | null,
      provider_hook_event?: string | null,
      id?: string | null,
      paymentStatus?: string | null,
      status?: string | null,
      amountWinning?: number | null,
      contract?: string | null,
      note?: string | null,
      desk?:  {
        __typename: "CashDesk",
        PK?: string | null,
        SK?: string | null,
        name?: string | null,
        id?: string | null,
        station?: string | null,
        backgroundImg?: string | null,
        screenLocked?: boolean | null,
      } | null,
      sign?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetBettingsListQuery = {
  getBettingsList?:  {
    __typename: "AccountMovementCashDeskConnection",
    items?:  Array< {
      __typename: "AccountMovementCashDesk",
      PK: string,
      SK: string,
      orderId: string,
      createdAt: string,
      valute?: string | null,
      gameSession?: string | null,
      provider_hook?: string | null,
      updatedAt?: string | null,
      amount?: number | null,
      provider?: string | null,
      username?: string | null,
      description?: string | null,
      provider_hook_event?: string | null,
      id?: string | null,
      paymentStatus?: string | null,
      status?: string | null,
      amountWinning?: number | null,
      contract?: string | null,
      note?: string | null,
      desk?:  {
        __typename: "CashDesk",
        PK?: string | null,
        SK?: string | null,
        name?: string | null,
        id?: string | null,
        station?: string | null,
        backgroundImg?: string | null,
        screenLocked?: boolean | null,
      } | null,
      sign?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetContractQueryVariables = {
  contractnumber: string,
};

export type GetContractQuery = {
  getContract?:  {
    __typename: "Contract",
    PK?: string | null,
    SK?: string | null,
    createdAt?: string | null,
  } | null,
};

export type UpdateAccountSubscriptionVariables = {
  PK: string,
};

export type UpdateAccountSubscription = {
  updateAccount?:  {
    __typename: "Account",
    PK: string,
    SK: string,
    accountState?: string | null,
    deposit?: number | null,
    bonus?: number | null,
    withdrawable?: number | null,
    valute?: string | null,
    createdAt?: string | null,
    lastDepositDate?: string | null,
    weekTotal?: number | null,
    monthTotal?: number | null,
    depositLimit?: number | null,
    depositLimitPeriod?: Period | null,
    pickedUp?: number | null,
    expenses?: number | null,
    updatedAt?: string | null,
    winnings?: number | null,
  } | null,
};

export type OnWinningSubscription = {
  onWinning?:  Array< {
    __typename: "WinningsUsers",
    username?: string | null,
    amount?: number | null,
    amountWinning?: number | null,
    valute?: string | null,
  } | null > | null,
};
